import { callAuthorizedGraphQLEndpoint } from 'Module/graphQL'

const updateCountriesDefaultSettings = input => {
  const query = `
    mutation ($input: CountriesDefaultSettingsInput!) {
        updateCountriesDefaultSettings(input:$input){
            success
            error
        }
      }
  `
  return callAuthorizedGraphQLEndpoint(query, { input })
}

const updateCitiesSettings = input => {
  const query = `
      mutation ($input: CitiesSettingsInput!) {
          updateCitiesSettings(input:$input){
              success
              error
          }
        }
    `
  return callAuthorizedGraphQLEndpoint(query, { input })
}

const updateSelfServeCitySettings = input => {
  const query = `
      mutation ($input: CitiesSettingsNodesInput) {
          updateSelfServeCitySettings(input:$input){
            success
            error
          }
        }
    `
  return callAuthorizedGraphQLEndpoint(query, { input })
}

const updatePrintingCosts = input => {
  const query = `
      mutation ($input: PrintingCostsInput!) {
        updatePrintingCosts(input:$input){
            nodes {
              id,
              countryId,
              label,
              value,
              flyersCount,
              index,
            }
            error
          }
        }
    `
  return callAuthorizedGraphQLEndpoint(query, { input })
}

const updateDMPrintingCosts = input => {
  const query = `
      mutation ($input: DMPrintingCostsInput!) {
        updateDMPrintingCosts(input:$input){
            DMPrintingCosts {
              countryId
              label
              value
              flyersCount
              version
              updatedAt
              updatedBy 
            } 
            error
          }
        }
    `
  return callAuthorizedGraphQLEndpoint(query, { input })
}

const updateADMPrintingCosts = input => {
  const query = `
      mutation ($input: ADMPrintingCostsInput!) {
        updateADMPrintingCosts(input:$input){
            ADMPrintingCosts {
              countryId
              label
              value
              flyersCount
              version
              updatedAt
              updatedBy 
            } 
            error
          }
        }
    `
  return callAuthorizedGraphQLEndpoint(query, { input })
}

const updatePrinterCosts = input => {
  const query = `
      mutation ($input: PrinterCostsInput!) {
        updatePrinterCosts(input:$input){
            PrinterCosts {
              printerId
              id
            } 
            error
          }
        }
    `
  return callAuthorizedGraphQLEndpoint(query, { input })
}

const updateChannels = input => {
  const query = `
      mutation ($input: ChannelsInput!) {
        updateChannels(input:$input){
            nodes {
              countryId,
              selectedChannels,
              customChannels,
            }
            error
          }
        }
    `
  return callAuthorizedGraphQLEndpoint(query, { input })
}

export {
  updateCountriesDefaultSettings,
  updateCitiesSettings,
  updatePrintingCosts,
  updateDMPrintingCosts,
  updateADMPrintingCosts,
  updatePrinterCosts,
  updateSelfServeCitySettings,
  updateChannels,
}
